import CustomButton from "../CustomButton";
import ModalLayout from "../layouts/ModalLayout";

interface Props {
  onClose?: () => void;
  onConfirm?: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  width?: string;
}

export default function ConfirmationModal({
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "No",
  cancelText = "cancel",
  confirmColor = "bg-error-600",
  width = "max-w-xs"
}: Props) {
  return (
    <ModalLayout onClose={onClose} width={width}>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
        <h4 className="text-xl font-semibold text-neutral-400">
          {title}
        </h4>
        {message && (
          <p className="text-neutral-500 text-sm">
            {message}
          </p>
        )}
        </div>
        <div className="flex justify-end items-end gap-4">
          <CustomButton
            text={cancelText}
            color="bg-neutral-200"
            onClick={onClose}
          />
          <CustomButton
            text={confirmText}
            color={confirmColor}
            onClick={onConfirm}
          />
        </div>
      </div>
    </ModalLayout>
  );
}